import Validator from './Validator';

export default class StringValidator extends Validator {
  constructor(minLength = 0, maxLength = null) {
    super();
    this.minLength = minLength;
    this.maxLength = maxLength;

    this.tooShortMessage = `Must contain at least ${this.minLength} characters.`;

    if (maxLength !== null) { this.tooLongMessage = `Must not contain more than ${this.maxLength} characters.`; }
  }

  validate(input, humanValidated = false) {
    this.isValid = super.validate(input);
    this.validationMessage = '';
    this.humanValidated = humanValidated;

    // Implemented in subclass
    if (input.length < this.minLength) {
      this.validationMessage = this.tooShortMessage;
      this.isValid = false;
    }

    if (this.maxLength !== null) {
      if (input.length > this.maxLength) {
        this.validationMessage = this.tooLongMessage;
        this.isValid = false;
      }
    }

    this.tested = true;
  }
}
